import React, { useState } from 'react';
import {
  VertModal,
  VertContainer,
  VertButton,
  Typography,
  VertInput,
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';

const ReturnConciergeListConfirmationModal = ({ isOpen, onClose, goToList }) => {
  return (
    <VertModal
      destroyOnClose={true}
      open={isOpen}
      onCancel={() => onClose()}
      className="modal-text-padding width-modal"
    >
      <VertContainer className="text-weight-modal-confirmation margin-bottom-divider margin-top-divider">
        <Typography.Title level={2} className='color-title margin-bottom-divider-title' >
          {`Voltar para as solicitações de produtos e serviços`}
        </Typography.Title>
        <Typography.Text>
          {`Você deseja voltar para as solicitações de produtos e serviços? Os dados não salvos serão perdidos`}
        </Typography.Text>
      </VertContainer>

      <Row className='margin-top-divider' justify={"end"}>
        <Col>
          <VertButton
            className='button-continue margin-button-send button-concierge'
            type='default'
            size="default"
            onClick={() => onClose()}
          >
            Não
          </VertButton>
        </Col>
        <Col>
          <VertButton
            className='button-continue margin-button-send button-concierge'
            type='highlight'
            size="default"
            onClick={() => goToList()}
          >
            Sim
          </VertButton>
        </Col>
      </Row>
    </VertModal >
  );
};

export default ReturnConciergeListConfirmationModal;
